export const LIST_TRANSFER_WITH_AMOUNT = 'LIST_TRANSFER_WITH_AMOUNT';
export const FETCH_TRANSFER_WITH_AMOUNT = 'FETCH_TRANSFER_WITH_AMOUNT';
export const LIST_TRANSFER_WITH_PERCENTAGE = 'LIST_TRANSFER_WITH_PERCENTAGE';
export const FETCH_TRANSFER_WITH_PERCENTAGE = 'FETCH_TRANSFER_WITH_PERCENTAGE';
